import { SEARCHED_USER_IDS_CHANGED } from './actions';

const initialState = {
  users: [],
  loading: true,
  filteredUserIds: null,
  searching: false,
  usersMeta: {},
  searchedUserIds: []
};

function usersReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCHED_USER_IDS_CHANGED:
      return {
        ...state,
        searchedUserIds: action.userIds
      };
    default:
      return state;
  }
}

export default usersReducer;
